import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoadingSpinner',
    props: {
        size: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["loader", { 'small': _ctx.size == 'small', 'medium': !_ctx.size || _ctx.size == 'medium', 'large': _ctx.size == 'large' }])
            }, null, 2));
        };
    }
});
